import React, { useContext } from 'react';
import Heading from 'components/Heading';
import { CommentSizesContext } from '../Context';

/**
 * This component will focus its heading component
 * when the current page of the comments section changes
 */
import { jsx as _jsx } from "react/jsx-runtime";
function CommentsTitle(_ref) {
  var children = _ref.children;
  var size = useContext(CommentSizesContext);
  return /*#__PURE__*/_jsx(Heading, {
    as: "h2",
    size: size === 'DEFAULT' ? 'small' : 'medium',
    breakpoints: "m",
    children: children
  });
}
export default CommentsTitle;